import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedMessage } from 'react-intl';
import get from 'lodash.get';

import CartPrice from './CartPrice';
import CartPriceRow from './CartPriceRow';
import CartNoShipping from './CartNoShipping';

const CartPriceTable = ({
    user,
    item,

    currency,
    privateOffer,
    salePrice,
    retailPrice,
    netPrice,
    shippingPrice,
    subTotal,
}) => {
    const isFurniture = get(item, 'isFurniture');
    const canUseNetPrice = get(user, 'canUseNetPrice');

    return (
        <div>
            {privateOffer && (
                <CartPriceRow
                    label={
                        <FormattedMessage
                            id="CartPriceTable.privateOffer"
                            defaultMessage="Private Offer"
                        />
                    }
                >
                    <CartPrice
                        currency={currency}
                        item={item}
                        dataTn="cart-private-offer"
                        price={privateOffer}
                    />
                </CartPriceRow>
            )}
            {salePrice !== null && (
                <CartPriceRow
                    isStrikeOut={!!privateOffer}
                    label={
                        <FormattedMessage
                            id="CartPriceTable.salePrice"
                            defaultMessage="Sale Price"
                        />
                    }
                >
                    <CartPrice
                        currency={currency}
                        item={item}
                        dataTn="cart-sale"
                        price={salePrice}
                    />
                </CartPriceRow>
            )}
            {netPrice !== null && (
                <CartPriceRow
                    isStrikeOut={!!privateOffer}
                    label={
                        <FormattedMessage id="CartPriceTable.netPrice" defaultMessage="Net Price" />
                    }
                >
                    <CartPrice currency={currency} item={item} dataTn="cart-net" price={netPrice} />
                </CartPriceRow>
            )}
            {retailPrice !== null && (
                <CartPriceRow
                    isStrikeOut={!!privateOffer}
                    label={
                        canUseNetPrice && isFurniture ? (
                            <FormattedMessage
                                id="CartPriceTable.listPrice"
                                defaultMessage="List Price"
                            />
                        ) : (
                            <FormattedMessage id="CartPriceTable.price" defaultMessage="Price" />
                        )
                    }
                >
                    <CartPrice
                        currency={currency}
                        item={item}
                        dataTn="cart-retail"
                        price={retailPrice}
                    />
                </CartPriceRow>
            )}
            <CartPriceRow
                label={<FormattedMessage id="CartPriceTable.shipping" defaultMessage="Shipping" />}
            >
                {shippingPrice ? (
                    <CartPrice
                        currency={currency}
                        prefix={
                            <FormattedMessage
                                id="CartPriceTable.starts"
                                defaultMessage="starts at"
                            />
                        }
                        item={item}
                        dataTn="cart-retail"
                        price={shippingPrice}
                    />
                ) : (
                    <CartNoShipping item={item} />
                )}
            </CartPriceRow>
            <CartPriceRow
                hasTopLine
                label={<FormattedMessage id="CartPriceTable.subTotal" defaultMessage="Subtotal" />}
            >
                <CartPrice
                    currency={currency}
                    item={item}
                    dataTn="cart-subTotal"
                    price={subTotal}
                />
            </CartPriceRow>
        </div>
    );
};

CartPriceTable.propTypes = {
    user: PropTypes.object.isRequired,
    item: PropTypes.object.isRequired,

    currency: PropTypes.string.isRequired,

    // Prices
    privateOffer: PropTypes.number,
    salePrice: PropTypes.number,
    retailPrice: PropTypes.number,
    netPrice: PropTypes.number,
    shippingPrice: PropTypes.number,
    subTotal: PropTypes.number,
};

export default createFragmentContainer(CartPriceTable, {
    user: graphql`
        fragment CartPriceTable_user on User {
            canUseNetPrice
        }
    `,
    item: graphql`
        fragment CartPriceTable_item on Item {
            ...CartPrice_item
            ...CartNoShipping_item
            isFurniture
            pricing {
                purchasable
            }
        }
    `,
});
